<template>
	<section class="ss-footer" :class="['ss-footer__mode_' + mode]">
		<div class="ss-container" v-if="mode !== 99">
			<div class="ss-footer-top">
				<img src="~@/assets/img/main/logo-white.png" />
			</div>
			<div class="ss-footer-bottom clearfix">
				<div class="ss-footer-bottom__left">
					<p>主办单位：北京市大兴区数字文化馆</p>
					<p>Copyright www.daxingwhg.com, All Rights Reserved.
						<a href="https://beian.miit.gov.cn/#/Integrated/index" style="cursor: pointer;" target="_blank">京ICP备17055194号-9</a>
					</p>
					<div class="link-list">
						<div>友情链接：</div>
						<div>
							<span v-for="(item, index) in linkList"><a target="_blank" :href="item.linkUrl" >{{ item.linkName }}</a>
							<span v-if="index < linkList.length - 1 && ((index+1) % 3)!==0"><span style="margin: 0 10px">|</span> </span>
							<br v-if="((index+1) % 3)===0" /> </span>
						</div>
					</div>
				</div>
				<div class="ss-footer-bottom__right">
					<div class="ss-footer-bottom__right_item">
						<img src="~@/assets/img/main/wx.png" />
						<img class="hover-image" :src="gzhUrl" />
						公众号
					</div>
					<a class="ss-footer-bottom__right_item" target="_blank" href="https://weibo.com/bjwhyshdzx">
						<img src="~@/assets/img/main/wb.png" />
						微博
					</a>
					<div class="ss-footer-bottom__right_item">
						<div class="ss-footer-bottom__right_row">
							<div>
								<img src="~@/assets/img/main/tel.png" />
								010-69294359
							</div>
							<div>
								<img src="~@/assets/img/main/yx.png" />
								whgxinxibu@126.com
							</div>
						</div>
					</div>
				</div>
			</div>
		 	<div style="color: #999999;font-size: 12px;margin-top: 10px;display: flex;justify-content: space-between;">
				<div>
					<router-link to="/agreement">用户协议</router-link> | <router-link to="/feedback">意见反馈</router-link> | <router-link to="/about/contact">联系我们</router-link>
				</div>
				<div>版权所有：北京市大兴区数字文化馆</div>
			</div>
		</div>
		<template v-else>
			<p class="copy-right-text">Copyright © www.daxingwhg.com, All Rights Reserved.<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备17055194号-9</a></p>
			<p class="copy-right-text">版权所有：北京市大兴区数字文化馆</p>
		</template>
	</section>
</template>

<script>
	import {BASE_URL} from "@/config";

	export default {
		data() {
			return {
				linkList: [],
				mode: 2,
				// gzhUrl: 'https://tvax2.sinaimg.cn/crop.0.0.512.512.180/8fef3dadly8gdin845plrj20e80e840u.jpg?KID=imgbed,tva&Expires=1607443625&ssig=76CWlU%2FFSa',
				gzhUrl: BASE_URL + '/u/cms/resources/officialAccountQrcode.jpg',
			}
		},
		watch: {
			'$route.path': {
				handler: function(val, oldVal){
					let { mode = 2 } = this.$route.meta || {};
					this.mode = mode;
				},
				deep: true,
				immediate: true
			}
		},
		created() {
			this.getData();
		},
		methods: {
			async getData(){
				let res = await this.$http('linkList', {})
				console.log(res)
				if(res.code === 1){
					this.linkList =  res.data;
					console.log("linkList",this.linkList)
				}
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.ss-footer{
		padding: 41px 0 40px;
		background-color: #333333;
		&.ss-footer__mode_99{
			background-color: transparent;
			padding: 70px;
			.copy-right-text{
				font-size: 12px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #9A9A9A;
				line-height: 26px;
				text-align: center;
			}
		}
		.ss-footer-bottom{
			margin-top: 20px;
			.ss-footer-bottom__right{
				width: 50%;
				float: right;
				text-align: right;
				.ss-footer-bottom__right_item{
					display: inline-block;
					text-align: center;
					margin-left: 40px;
					font-size: 12px;
					line-height: 30px;
					color: #999999;
					position: relative;
					img{
						height: 30px;
						display: block;
						margin: 0 auto;
					}
					.hover-image{
						opacity: 0;
						@include abs(40px, 50%);
						width: 120px;
						margin-right: -60px;
						@include tst();
						height: 0;
					}
					&:hover{
						.hover-image{
							opacity: 1;
							height: 120px;
						}
					}
					.ss-footer-bottom__right_row{
						text-align: left;
						img{
							height: 22px;
							vertical-align: middle;
							display: inline-block;

						}
					}
				}
			}
			.ss-footer-bottom__left{
				float: left;
				width: 50%;
				font-size: 12px;
				line-height: 30px;
				color: #999999;
			}
		}
		.ss-footer-top{
			img{
				height: 45px;
				display: block;
			}
		}
		.link-list{
			display: flex;
		}
	}
</style>
